import {
  Component,
  inject,
  LOCALE_ID,
  input,
  signal,
  HostListener,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, ControlContainer, FormGroup } from '@angular/forms';
import {
  ProductAutocompleteItem,
  SupplierItem,
} from '../../../../pages/admin-dashboard/stock-management/add-all-stock/add-stock.model';
import { Error } from '../../../public-user-component/auth/shared/error/error';

@Component({
  selector: 'app-stock-information',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, Error],
  templateUrl: './stock-information.html',
    styleUrl: './stock-information.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
})
export class StockInformation {
  private container = inject(ControlContainer);
  private locale = inject(LOCALE_ID);
  private eRef = inject(ElementRef);
  type = input<'create' | 'edit'>('create');

  productId = input<number | null>(null);
  suppliers = input<SupplierItem[]>([]);
  productsAutocomplete = input<ProductAutocompleteItem[]>([]);
  showAutocomplete = input<boolean>(false);

  @Output() searchProduct = new EventEmitter<string>();
  @Output() productSelected = new EventEmitter<ProductAutocompleteItem>();
  @Output() closeAutocomplete = new EventEmitter<void>();

  get form(): FormGroup {
    return this.container.control as FormGroup;
  }

  isArabic(): boolean {
    return this.locale.startsWith('ar');
  }

  err(field: string, errorKey: string): boolean {
    const ctrl = this.form.get(field);
    return !!(ctrl?.hasError(errorKey) && (ctrl?.touched || this.form.touched));
  }

  invalid(field: string): boolean {
    const ctrl = this.form.get(field);
    return !!(ctrl?.invalid && (ctrl?.touched || this.form.touched));
  }

  onSearch(event: Event) {
    const term = (event.target as HTMLInputElement).value;

    if (!term || term.trim().length === 0) {
      this.closeAutocomplete.emit();
    } else {
      this.searchProduct.emit(term);
    }
  }

  select(prod: ProductAutocompleteItem) {
    this.productSelected.emit(prod);
  }

  @HostListener('document:click', ['$event'])
  clickout(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.closeAutocomplete.emit();
    }
  }
}
